<template>
<div id="apppnf" v-cloak>
    <h1 style="margin-top:30px;" class="text-center">Ops! Pagina non trovata</h1>
</div>
</template>

<script>
export default {
    name: 'apppnf',
    data: function () {
        return {};
    },
    methods: {

    },
    created: function () {
        
        
        
    }
}
</script>
